import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { CloseOutlined, DeleteOutline } from "@mui/icons-material";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import HotelApi from "Services/Hotel";

const HotelDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [profileimage, setprofileimage] = useState(null);
  const [username, setusername] = useState(null);

  const getDetails = useCallback(() => {
    if (!id) return;
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        const d = Array.isArray(res?.data?.data) ? res.data.data[0] : res.data.data;
        setprofileimage(d?.image);
        setusername(d?.firstName);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    HotelApi.getHotelDetails(id).then(onSuccess, onFailure);
  }, [id, dispatch]);

  useEffect(() => {
    if (openDialog) {
      getDetails();
    }
  }, [openDialog, getDetails]);

  const handleDeleteHotel = () => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Hotel Deleted Successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while deleting Hotel",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };

    HotelApi.deleteHotel(id).then(onSuccess, onFailure);
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      {/* Header */}
      <Box className={classes.dialogHeader}>
        <Typography className={classes.dialogHeaderTitle}>Delete Hotel / Restaurant</Typography>
        <IconButton className={classes.closeIconBtn} onClick={handleClose}>
          <CloseOutlined />
        </IconButton>
      </Box>

      {/* Body */}
      <Box className={classes.dialogBody}>
        <Box className={classes.avatarWrapper}>
          <img
            src={profileimage || "/assets/images/user/avatar.png"}
            alt="Hotel"
            className={classes.avatarImg}
          />
          <Typography className={classes.nameText}>{username || "This hotel"}</Typography>
        </Box>
        <Typography className={classes.descriptionText}>
          Are you sure you want to delete <strong>{username || "this hotel"}</strong>? This action cannot be undone and all associated data will be permanently removed.
        </Typography>
      </Box>

      {/* Footer */}
      <Box className={classes.dialogFooter}>
        <Button className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={classes.deleteButton}
          onClick={handleDeleteHotel}
          startIcon={<DeleteOutline />}
        >
          Delete Hotel
        </Button>
      </Box>
    </Dialog>
  );
};

export default HotelDelete;
